var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7293 30.7431C24.1478 30.7431 30.9723 23.9186 30.9723 15.5001C30.9723 7.0816 24.1478 0.25708 15.7293 0.25708C7.31085 0.25708 0.486328 7.0816 0.486328 15.5001C0.486328 23.9186 7.31085 30.7431 15.7293 30.7431Z",
    fill: "#C1CCD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5744 15.2571H7.48438",
    stroke: "#0A1E5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.6fb876be3c990290d7ae52d6cb920900.svg";
export { ForwardRef as ReactComponent };